module.exports = __webpack_public_path__ + "static/media/qrcode.4827c536.svg";